import React from 'react';
import { ReservoirGraphs } from '../../components/Reservoir/ui/mapcomponent/AllCharts/AllCharts'; 

const AllChartsPage: React.FC = () => {
  const handleReset = () => {
    // Implement reset logic here
  };

  const handleSearch = () => {
    // Implement search logic here
  };

  const handleOpenAddModal = () => {
    // Implement open add modal logic here
  };

  const handleOpenReportModal = () => {
    // Implement open report modal logic here
  };

  return (
    <div>
      <ReservoirGraphs 
        onReset={handleReset}
        onSearch={handleSearch}
        openAddModal={handleOpenAddModal}
        openReportModal={handleOpenReportModal}
      />
    </div>
  );
};

export default AllChartsPage;